import { useTranslation } from 'next-i18next'
import { makeStyles, Container } from '@material-ui/core'
import T from '../../home-new/tokens'
import Reveal from '../../home-new/Reveal'

// "โซลูชันสำหรับธุรกิจ" — 2 horizontal cards (icon left, title + desc right,
// dark pill button below), for SHIPPOP Business and API / Plugin & Module.
// Copy is i18n-keyed under services.new.solutions.* (title-1/title-2/desc/cta).
const cards = [
  { key: 'card1', icon: '/static/img/service-new/v2/solutions/business.png', href: '/business' },
  { key: 'card2', icon: '/static/img/service-new/v2/solutions/api.png', href: '/business#connect' },
]

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '70px 0',
    background: T.color.canvas,
    [theme.breakpoints.down('sm')]: { padding: '44px 0' },
  },
  heading: {
    fontFamily: T.font.heading,
    fontSize: 32,
    fontWeight: 700,
    color: T.color.ink,
    textAlign: 'center',
    margin: '0 0 10px',
    '& span': { color: T.color.brand },
    [theme.breakpoints.down('sm')]: { fontSize: 22 },
  },
  sub: {
    fontFamily: T.font.body,
    fontSize: 17,
    color: T.color.muted,
    textAlign: 'center',
    margin: '0 0 40px',
    [theme.breakpoints.down('sm')]: { fontSize: 15, margin: '0 0 26px' },
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '28px',
    [theme.breakpoints.down('sm')]: { gridTemplateColumns: '1fr', gap: '18px' },
  },
  card: {
    background: T.color.surface,
    borderRadius: 24,
    boxShadow: T.shadow.card,
    padding: '34px 34px 30px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    transition: 'transform 0.25s ease, box-shadow 0.25s ease',
    '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 16px 36px rgba(0,102,204,0.14)' },
    [theme.breakpoints.down('sm')]: { padding: '28px 24px 24px' },
  },
  top: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '22px',
    marginBottom: 24,
    flexGrow: 1,
    [theme.breakpoints.down('xs')]: { flexDirection: 'column', alignItems: 'center', textAlign: 'center' },
  },
  iconWrap: {
    flexShrink: 0,
    width: 92,
    height: 92,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': { maxWidth: 92, maxHeight: 92, objectFit: 'contain' },
  },
  cardTitle: {
    fontFamily: T.font.heading,
    fontSize: 22,
    fontWeight: 700,
    color: T.color.ink,
    margin: '4px 0 10px',
    '& span': { color: T.color.brand },
    [theme.breakpoints.down('sm')]: { fontSize: 19 },
  },
  cardDesc: {
    fontFamily: T.font.body,
    fontSize: 15,
    color: T.color.muted,
    lineHeight: 1.7,
    margin: 0,
  },
  btn: {
    alignSelf: 'flex-start',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 46,
    minWidth: 236,
    padding: '0 26px',
    borderRadius: T.radius.pill,
    background: T.color.ink,
    color: T.color.onBrand,
    fontFamily: T.font.heading,
    fontSize: 15,
    fontWeight: 500,
    textDecoration: 'none',
    transition: 'transform 0.2s ease, background 0.2s ease',
    '&:hover': { transform: 'translateY(-2px)', background: T.color.brandDeep, color: T.color.onBrand },
    [theme.breakpoints.down('xs')]: { alignSelf: 'stretch' },
  },
}))

const BusinessSolutions = () => {
  const classes = useStyles()
  const { t } = useTranslation('services')
  return (
    <section className={classes.root} id="solutions">
      <Container maxWidth={false} style={{ maxWidth: T.container }}>
        <Reveal>
          <h2 className={classes.heading}>
            {t('new.solutions.heading-lead')}
            <span>{t('new.solutions.heading-highlight')}</span>
          </h2>
          <p className={classes.sub}>{t('new.solutions.sub')}</p>
        </Reveal>
        <div className={classes.grid}>
          {cards.map((c, i) => (
            <Reveal key={c.key} delay={i * 0.12}>
              <div className={classes.card}>
                <div className={classes.top}>
                  <span className={classes.iconWrap}>
                    <img src={c.icon} alt="" aria-hidden="true" loading="lazy" />
                  </span>
                  <div>
                    <h3 className={classes.cardTitle}>
                      <span>{t(`new.solutions.${c.key}.title-1`)}</span>
                      {t(`new.solutions.${c.key}.title-2`)}
                    </h3>
                    <p className={classes.cardDesc}>{t(`new.solutions.${c.key}.desc`)}</p>
                  </div>
                </div>
                <a href={c.href} className={classes.btn}>
                  {t(`new.solutions.${c.key}.cta`)}
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  )
}

export default BusinessSolutions
